import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { MainserviceService } from '../../mainservice.service';

@Component({
  selector: 'app-shop-promocodes',
  templateUrl: './shop-promocodes.component.html',
  styleUrls: ['./shop-promocodes.component.scss']
})
export class ShopPromocodesComponent implements OnInit {
   promos:any
   shopid:any
   
   promoFilter:any = { code: ''}
   
    //initializing p to one
    p: number = 1; 
  
  constructor(
    private authservice: AuthService,
    private mainservice:MainserviceService,
  ) { }

  ngOnInit() {
    let shop = JSON.parse(localStorage.getItem('USER'))
    this.shopid = shop.info.id
    this.mainservice.getShopPromocodes(shop.info.id).subscribe(data =>{
      this.promos =data
    })
  }


}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shop/shop-promocodes/shop-promocodes.component.ts